import React, { useState } from 'react';

import Box from '@mui/material/Box';

import Drawer from '../shared/Drawer';
import Dropzone from '../shared/dropzone/Dropzone';

const UploadProductsModal = (props) => {
  const {
    open,
    onClose,
    onUpload,
    loading,
  } = props;

  const [files] = useState([]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Upload Products"
      subtitle="Import new products"
      hideSubmit
    >
      <Box sx={{ minWidth: { md: 400 } }}>
        <Dropzone
          multiple={false}
          files={files}
          onUpload={onUpload}
          type="csv"
          text="Drag and drop .csv file here or click to upload"
          hideFilesList
          loading={loading}
        />
        <div className='m-t-sm'>
          <span className='font-bold'>Format:</span>
          <span className='m-l-sm'>Sku, Description</span>
        </div>
      </Box>
    </Drawer>
  );
};

export default UploadProductsModal;
